import React from "react";

const LightningIcon = ({ className = "", svgClassName = "", fill = "none" }) => {
  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`w-full h-full ${svgClassName}`}
      >
        <path
          d="M1.69446 8.47365L7.17758 1.43555C7.60639 0.885113 8.41019 1.22771 8.41019 1.96094V7.40851C8.41019 7.84771 8.72539 8.20381 9.11424 8.20381H11.7811C12.387 8.20381 12.71 9.01074 12.3097 9.52448L6.82658 16.5626C6.39777 17.113 5.59397 16.7704 5.59397 16.0372V10.5896C5.59397 10.1504 5.27875 9.79432 4.88992 9.79432H2.223C1.61717 9.79432 1.29423 8.98739 1.69446 8.47365Z"
          stroke="currentColor"
          fill={fill || "none"}
          strokeWidth="1.34"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default LightningIcon;
